export const fallbackCommon = {
  key: 'fallbackCommon',
  name: 'Fallback Common',
  siteIdentifier: 'global',

  loadingFallback: 'Loading...',
};
